const CLOSE_TYPE = {
    BUTTON: 'button',
    WEBVIEW: 'webviewlink',
    NONE: null,
};

const DEFAULT_LANG = 'en';

export { CLOSE_TYPE, DEFAULT_LANG }
